import { immerable } from "immer";
import PlanFormat from "../types/plan-format";
import PlanScale from "../types/plan-scale";
import PlanOrientation from "../types/plan-orientation";

class KnownScaleContent {
    [immerable] = true;

    format: PlanFormat = "A3";

    scale: PlanScale = "1:100";

    orientation: PlanOrientation = "LANDSCAPE";

    default = false; // Utilisez pour savoir si l'échelle est celle par défaut ou s'elle a été vraiment indiquée pour l'utilisateur

    static fromJSON(data: Record<string, unknown>) {
        const content = new KnownScaleContent();
        content.format = (data.format ?? data.Format) as PlanFormat ?? 'A3';
        content.scale = (data.scale ?? data.Scale) as PlanScale ?? '1:100';
        content.orientation = (data.orientation ?? data.Orientation) as PlanOrientation ?? 'LANDSCAPE';
        return content;
    }

    clone() {
        const content = new KnownScaleContent();
        content.format = this.format;
        content.scale = this.scale;
        content.orientation = this.orientation;
        content.default = this.default;
        return content;
    }
}

export default KnownScaleContent;